<template>
  <div class="news-list">
    <div class="list-item" v-for="(item,index) in newsList" :key="index" v-on:click="toNewsDetail(item.id)">
      {{ item.title}}
      <span class="date">{{item.publishDate}}</span>
    </div>
    <div class="list-pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalPages">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import {news} from 'src/api/stadiumApi'
  import {isNotEmpty} from 'src/utils/myUtils'

  export default {
    data () {
      return {
        pageSize: 3,
        pageNo: 1,
        totalPages: 1,
        newsList: []
      }
    },
    props: {
      sort: {
        required: true
      }
    },
    components: {},
    mounted () {
      this.$nextTick(function () {
      })
    },
    watch: {
      sort: function (val, oldVal) {
        if (isNotEmpty(val)) {
          this.pageNo = 1
          this.refreshNews()
        }
      }
    },
    methods: {
      refreshNews () {
        news(this.sort, this.pageNo, this.pageSize).then((resp) => {
          if (this.pageNo === 1) {
            this.newsList = []
          }
          this.newsList = this.newsList.concat(resp.content)
          this.totalPages = resp.totalPages
          if (this.pageNo < resp.totalPages) {
            this.pageNo++
          }
        })
      },
      toNewsDetail (id) {

      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/NewsList.vue